(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const image = root.querySelector('.fb-pdp__image');
      const zoomLink = root.querySelector('[data-zoom]');
      const thumbs = [...root.querySelectorAll('[data-thumbnail]')];
      const dialog = root.querySelector('dialog');
      const showImage = (thumb) => {
        if (!thumb || !image) return;
        image.src = thumb.dataset.src;
        image.srcset = thumb.dataset.srcset;
        image.alt = thumb.dataset.alt;
        zoomLink.href = thumb.href;
        thumbs.forEach((item) => item === thumb ? item.setAttribute('aria-current', 'true') : item.removeAttribute('aria-current'));
      };
      thumbs.forEach((thumb) => thumb.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); showImage(thumb);
      }));
      zoomLink?.addEventListener('click', (event) => {
        if (!dialog?.showModal || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const largeImage = dialog.querySelector('img');
        largeImage.src = zoomLink.href; largeImage.removeAttribute('srcset'); largeImage.alt = image.alt;
        dialog.querySelector('[data-full-image]').href = zoomLink.href;
        dialog.showModal();
      });
      dialog?.querySelector('[data-close-zoom]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog?.addEventListener('close', () => zoomLink.focus());
      const select = root.querySelector('[data-variant-select]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        root.querySelector('[data-product-price]').textContent = option.dataset.price;
        const compare = root.querySelector('[data-product-compare]');
        compare.textContent = option.dataset.compare; compare.hidden = !option.dataset.compare;
        const button = root.querySelector('[data-product-add]');
        button.disabled = !available; button.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
        root.querySelector('[data-product-stock]').textContent = !available ? root.dataset.soldLabel : option.dataset.stock === 'true' ? root.dataset.stockLabel : root.dataset.orderLabel;
        const quantity = root.querySelector('[name="quantity"]');
        quantity.disabled = !available;
        if (option.dataset.max && Number(option.dataset.max) > 0) { quantity.max = option.dataset.max; quantity.value = Math.max(1, Math.min(Number(quantity.value) || 1, Number(quantity.max))); }
        else { quantity.removeAttribute('max'); }
        root.querySelector('[data-product-sku]').textContent = option.dataset.sku;
        root.querySelector('[data-sku-row]').hidden = !option.dataset.sku;
        showImage(thumbs.find((thumb) => thumb.dataset.imageId === option.dataset.image));
        const url = new URL(window.location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
      });
    };
    const init = () => document.querySelectorAll('[data-product-page]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
